/**
 * PlaybookLockedList — the "Always applies" items: read-only, no controls.
 */

import { Lock } from 'lucide-react';

export function PlaybookLockedList({ items }: { items: string[] }) {
  return (
    <section aria-labelledby="playbook-locked-heading" className="flex flex-col gap-2" data-testid="playbook-locked-section">
      <h2 id="playbook-locked-heading" className="flex items-center gap-2 text-lg font-semibold text-foreground">
        <Lock className="h-4 w-4" aria-hidden="true" />
        Always applies
      </h2>
      <ul className="flex flex-col gap-1.5">
        {items.map((text, i) => (
          <li
            key={text}
            data-testid={`playbook-locked-item-${i}`}
            className="rounded-lg bg-muted px-3 py-2.5 text-sm text-foreground"
          >
            {text}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default PlaybookLockedList;
